export default {
  "Login Successful": "登陆成功",
  "Check Password": "检查密码",
  "Unknown Error": "未知错误",
};
